<template>
  <div class="g-table">
    <el-table
      id="dailyworkTable"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      height="100%"
      border
      @selection-change="selectionChange"
      :row-style="{ height: '30' }"
      :row-class-name="tableRowClassName"
    >
      <!-- check-->
      <el-table-column
        align="center"
        type="selection"
        width="34"
        :selectable="jinzhi"
      ></el-table-column>
      <!-- 姓名 -->
      <el-table-column align="center" label="姓名" min-width="110">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.employee_id"
            size="small"
            @change="update(scope.$index)"
            v-if="scope.row.zsflag == 1"
          >
            <el-option
              v-for="item in getDepartAndProjectData.employee_list"
              :label="item.employee_name"
              :value="item.employee_id"
              :key="item.employee_id"
            ></el-option>
          </el-select>
          <div v-if="scope.row.zsflag != 1 && tableData.length > 0">
            {{
              typeof getDepartAndProjectData.employee_list[
                scope.row.employee_id
              ] == "undefined"
                ? scope.row.employee_id
                : getDepartAndProjectData.employee_list[scope.row.employee_id]
                    .employee_name
            }}
          </div>
        </template>
      </el-table-column>
      <!-- 项目名称 -->
      <el-table-column
        align="center"
        label="项目名称"
        prop="project_name_cn"
        min-width="180"
      >
        <template slot-scope="scope">
          <div>
            {{ base_info.project_list[scope.row.project_id].project_name_cn }}
          </div>
        </template>
      </el-table-column>
      <!-- 阶段任务 -->
      <el-table-column align="center" label="阶段任务" min-width="380%">
        <template slot-scope="scope">
          <div>{{ scope.row.task_name_str }}</div>
        </template>
      </el-table-column>
      <!-- 工作时长 -->
      <el-table-column align="center" label="调休时长(H:M)" width="130%">
        <template slot-scope="scope" class="elTable">
          <table
            frame="void"
            @change="update(scope.$index)"
            v-if="
              scope.row.is_confirmed == 0 &&
              CtimeFlag == 'open' &&
              Cyshangban == '1'
            "
          >
            <tr>
              <td>
                <el-input
                  v-model="scope.row.show_hour"
                  size="small"
                  @change="update(scope.$index)"
                  style="text-align: center"
                ></el-input>
              </td>
              <td>
                <el-input
                  v-model="scope.row.show_min"
                  size="small"
                  @change="update(scope.$index)"
                  style="text-align: center"
                ></el-input>
              </td>
            </tr>
          </table>
          <div v-else>{{ scope.row.show_hour + ":" + scope.row.show_min }}</div>
        </template>
      </el-table-column>
      <!-- 工作内容 -->
      <el-table-column align="center" label="调休内容" width="400%">
        <template slot-scope="scope">
          <div>{{ scope.row.comments }}</div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        align="center"
        label="操作"
        width="130%"
        v-if="CtimeFlag == 'open' && Cyshangban == '1'"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            size="mini"
            @click="tablebianji(scope.$index, scope.row, 1)"
            v-show="scope.row.is_confirmed == 0"
          >
            <span class="edit-btn">确认通过</span>
          </el-button>
          <el-button
            type="danger"
            plain
            size="mini"
            @click="tablebianji(scope.$index, scope.row, 0)"
            v-show="scope.row.is_confirmed == 1"
            style="margin-left: 0"
          >
            <span class="edit-btn">取消通过</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getBaseInfo, getPerson } from "@/api/user";
import {
  hourToMin,
  myGrounpX,
  getTaskOptionValue,
  getOptionStrName,
} from "@/lib/until";
import { showLoading, hideLoading } from "@/lib/loading";
export default {
  name: "GetTable",
  data() {
    return {
      base_info: [], //基础列表
      depart_id: "", //部门id
      personId: "", //人员id
      password: "",
      getdataxm: "", //人员姓名
      getdataId: "",
      options: [], //项目阶段
    };
  },
  props: {
    CtableData: {
      type: Array,
      default: [],
    },
    CtimeFlag: {
      type: String,
      default: "",
    },
    Cyshangban: {
      type: Number,
    },
  },
  created() {
    this.getuserInfo();
    this.getTableData();
  },
  computed: {
    tableData() {
      return this.CtableData;
    },
  },
  methods: {
    //单行确认通过
    tablebianji(index, row, flag) {
      let sendObj = {};
      if (flag == 1) {
        row.zsflag = 4;
        row.is_confirmed = 1;
        sendObj.is_confirmed = 1;
      } else if (flag == 0) {
        row.is_confirmed = 0;
        sendObj.is_confirmed = 0;
      } else {
        return;
      }
      sendObj.daily_report_id = this.tableData[index].daily_report_id;
      this.$http
        .post(
          IPConfig.IP + "/kpi-management/dailyreport/update.php",
          JSON.stringify(sendObj),
          { emulateJSON: true }
        )
        .then();
    },
    tableRowClassName({ row, rowIndex }) {
      //console.log(row);
      if (row.colorTag === 1) {
        return "bgc-row";
      } else if (row.colorTag === 2) {
        return "sbgc-row";
      }
      return "";
    },

    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      this.depart_id = uesrInfo.depart_ID;
      this.personId = uesrInfo.employee_id;
      this.password = uesrInfo.password;
      //console.log(this.depart_id);
    },
    //禁止复选框选中
    jinzhi(row, index) {
      return row.is_confirmed == 0;
      //打开编辑页面
    },
    //获取姓名
    // cnName(row, column) {
    //   //console.log(row)
    //   if (typeof row != "undefined") {
    //     var employee_id = row.employee_id;
    //     if (typeof employee_id != "undefined") {
    //       let data = this.getDepartAndProjectData;
    //       if (typeof data != "undefined") {
    //         let employee_list = data.employee_list;
    //         if (typeof employee_list != "undefined") {
    //           let rowNameInfo = employee_list[employee_id];
    //           if (typeof rowNameInfo != "undefined") {
    //             let employee_name = rowNameInfo.employee_name;
    //             if (
    //               typeof employee_name != "undefined" &&
    //               employee_name != ""
    //             ) {
    //               //console.log(employee_name);
    //               return employee_name;
    //             } else {
    //               return employee_id;
    //             }
    //           }
    //         }
    //         // for(){

    //         // }
    //       }
    //     } else {
    //       return "";
    //     }
    //   }
    //   //console.log(row);
    //   //console.log(column);
    //   return "";
    // },
    getTableData() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      var department = JSON.parse(localStorage.getItem("department"));
      if (!department && typeof department != "undefined" && department != 0) {
        this.depart_id = uesrInfo.depart_ID;
      } else {
        this.depart_id = department.depart_id;
      }
      getBaseInfo().then((data) => {
        //console.log(this.depart_id);
        this.base_info = data;

        getPerson(this.depart_id).then((data) => {
          //console.log(data);
          this.getDepartAndProjectData = data;
          var phaseKeys = Object.keys(this.base_info.phase_list);
          //console.log(phaseKeys);
          for (var i = 0; i < phaseKeys.length; i++) {
            //插入新的对象
            this.options.push({});
            //定义简写
            var phase = this.base_info.phase_list[phaseKeys[i]];
            var Op = this.options[i];

            //获取value以及label的值
            this.options[i].value = phase.phase_id;

            this.options[i].label =
              phase.phase_abbr + "." + phase.phase_name_cn;

            //获取task_list,设置为第一层children
            Op.children = [];
            //console.log(Op);

            var keys = Object.keys(this.getDepartAndProjectData.task_list);
            //console.log("keys", keys);
            for (var k = 0; k < keys.length; k++) {
              var task = this.getDepartAndProjectData.task_list[keys[k]];
              //console.log("task", task);
              if (phase.phase_id == task.phase_id) {
                //判断是否有sub_task,设置第二层children
                Op.children.push(this.getOptionOfTask(task));

                //console.log("childern.children",this.getOptionOfTask(task));
              }
            }
          }
          let opt = this.options;
          let jieduan = this.getDepartAndProjectData;
          let baseInfo = this.base_info;
          this.$emit("getdata", opt, jieduan, baseInfo);
          this.$emit("bmchange", this.$root.Time);
        });
      });
    },
    getOptionOfTask(task) {
      var temp = {
        value: task.task_id,
        label: task.task_abbr + "." + task.task_name_cn,
      };
      var subtaskkeys = Object.keys(task.sub_task);
      for (var i = 0; i < subtaskkeys.length; i++) {
        if (i == 0) {
          temp.children = [];
        }

        temp.children.push(this.getOptionOfTask(task.sub_task[subtaskkeys[i]]));
      }

      ////console.log(temp);
      return temp;
    },
    //提交数据
    update(index) {
      var Msg = this.tableData[index];
      this.checkInput(Msg);
      Msg.depart_id = this.depart_id;
      Msg.daily_report_date = this.$root.Time;
      //phase-id与project-id
      if (Msg.daily_report_id != -1) {
        this.$http
          .post(
            IPConfig.IP + "/kpi-management/dailyreport/update.php",
            JSON.stringify(this.updateJSONmsg(Msg)),
            { emulateJSON: true }
          )
          .then();
      } else if (
        Msg.employee_id != "" &&
        Msg.project_id != "" &&
        Msg.value1.length != 0 &&
        Msg.comments != "" &&
        Msg.show_hour != "" &&
        Msg.show_min != ""
      ) {
        //console.log("获取")
        var addMsg = this.updateJSONmsg(Msg);
        this.$http
          .post(
            IPConfig.IP + "/kpi-management/dailyreport/create.php",
            JSON.stringify(addMsg),
            { emulateJSON: true }
          )
          .then(function (res) {
            var getDaily_report_id = res.body;
            addMsg.daily_report_id = getDaily_report_id.daily_report_id;
            //console.log(getDaily_report_id.daily_report_id);
            this.$http
              .post(
                IPConfig.IP + "/kpi-management/dailyreport/update.php",
                JSON.stringify(addMsg),
                { emulateJSON: true }
              )
              .then(function (res) {
                //console.log(res.body);
              });
          });
      }
      //console.log("this.tableData", this.tableData);
    },
    checkInput(vms) {
      if (isNaN(Number(vms.show_hour))) {
        vms.show_hour = "0";
      }
      var tempMin = Number(vms.show_min);
      if (isNaN(tempMin) || tempMin < 0) {
        vms.show_min = "0";
      } else if (tempMin > 59) {
        vms.show_min = "59";
      }
    },
    getEmployeeWorkHoursSum(employee_id) {
      var sum = 0;
      for (var i = 0; i < this.tableData.length; i++) {
        if (employee_id == this.tableData[i].employee_id) {
          sum += Number(this.tableData[i].work_hour);
        }
      }
      return sum;
    },
    minToHour(vms) {
      //work_hour格式化
      var hourvalue = Number(vms.show_hour) + Number(vms.show_min) / 60;
      vms.work_hour = String(hourvalue.toFixed(3));
    },
    updateJSONmsg(updateMsg) {
      if (updateMsg.value1.length == 3) {
        updateMsg.task_id = updateMsg.value1[2];
        updateMsg.phase_id = updateMsg.value1[0];
      }
      if (updateMsg.value1.length == 2) {
        updateMsg.task_id = updateMsg.value1[1];
        updateMsg.phase_id = updateMsg.value1[0];
      }
      this.minToHour(updateMsg);
      //转成JSON数据
      return updateMsg;
      //发送数据
    },

    formatter(row, column) {
      //console.log(row.employee_id);
      if (row.employee_id == this.getdataId) {
        //console.log(this.getdataxm);
        return this.getdataxm;
      }
      // return row.address;
    },

    // //生成excel表格
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    exportToExcel() {
      var printdailyworktable = [];
      printdailyworktable = this.getHeadername();

      console.log(printdailyworktable);
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../vendor/Export2Excel");
        const tHeader = [
          "日期",
          "姓名",
          "部门",
          "项目",
          "项目阶段",
          "上班时长",
          "工作内容",
        ];
        const filterVal = [
          "date",
          "name",
          "depart",
          "project",
          "phase_task",
          "work_hour",
          "comments",
        ];
        const list = printdailyworktable;
        const data = this.formatJson(filterVal, list);
        var exceldepart_name = "";
        var departIdKeys = Object.keys(this.base_info.depart_list);
        for (var n = 0; n < departIdKeys.length; n++) {
          if (
            this.depart_id ==
            this.base_info.depart_list[departIdKeys[n]].depart_id
          )
            exceldepart_name =
              this.base_info.depart_list[departIdKeys[n]].depart_name;
        }
        export_json_to_excel(
          tHeader,
          data,
          "调休_" + this.$root.Time + "_" + exceldepart_name
        );
      });
    },
    getHeadername() {
      var printTabledata = [];
      var exceltablerowdata = {
        date: "",
        name: "",
        depart: "",
        project: "",
        phase_task: "",
        work_hour: "",
        comments: "",
      };

      //获取id对应的中文名称
      var employeeIdKeys = Object.keys(
        this.getDepartAndProjectData.employee_list
      );
      var taskIdKeys = Object.keys(this.getDepartAndProjectData.task_list);
      var projectIdKeys = Object.keys(this.base_info.project_list);
      var departIdKeys = Object.keys(this.base_info.depart_list);
      //console.log('111');
      for (var i = 0; i < this.tableData.length; i++) {
        let tablerowdata = Object.assign({}, exceltablerowdata);
        for (var k = 0; k < employeeIdKeys.length; k++) {
          if (
            this.tableData[i].employee_id ==
            this.getDepartAndProjectData.employee_list[employeeIdKeys[k]]
              .employee_id
          )
            tablerowdata.name =
              this.getDepartAndProjectData.employee_list[
                employeeIdKeys[k]
              ].employee_name;
        }
        for (var j = 0; j < taskIdKeys.length; j++) {
          var sub_taskKeys = Object.keys(
            this.getDepartAndProjectData.task_list[taskIdKeys[j]].sub_task
          );
          if (
            this.tableData[i].task_id ==
            this.getDepartAndProjectData.task_list[taskIdKeys[j]].task_id
          ) {
            var sub_taskKeys = Object.keys(
              this.getDepartAndProjectData.task_list[taskIdKeys[j]].sub_task
            );
            tablerowdata.phase_task =
              this.getDepartAndProjectData.task_list[taskIdKeys[j]].task_abbr +
              "." +
              this.getDepartAndProjectData.task_list[taskIdKeys[j]]
                .task_name_cn;
          } else {
            for (var v = 0; v < sub_taskKeys.length; v++) {
              if (
                this.tableData[i].task_id ==
                this.getDepartAndProjectData.task_list[taskIdKeys[j]].sub_task[
                  sub_taskKeys[v]
                ].task_id
              ) {
                tablerowdata.phase_task =
                  this.getDepartAndProjectData.task_list[taskIdKeys[j]]
                    .sub_task[sub_taskKeys[v]].task_abbr +
                  "." +
                  this.getDepartAndProjectData.task_list[taskIdKeys[j]]
                    .sub_task[sub_taskKeys[v]].task_name_cn;
              }
            }
          }
        }
        for (var m = 0; m < projectIdKeys.length; m++) {
          if (
            this.tableData[i].project_id ==
            this.base_info.project_list[projectIdKeys[m]].project_id
          )
            tablerowdata.project =
              this.base_info.project_list[projectIdKeys[m]].project_name_cn;
        }
        for (var n = 0; n < departIdKeys.length; n++) {
          if (
            this.depart_id ==
            this.base_info.depart_list[departIdKeys[n]].depart_id
          )
            tablerowdata.depart =
              this.base_info.depart_list[departIdKeys[n]].depart_name;
        }

        tablerowdata.work_hour = this.tableData[i].work_hour;
        tablerowdata.comments = this.tableData[i].comments;
        tablerowdata.date = this.$root.Time;
        //console.log(tablerowdata);
        printTabledata.push(tablerowdata);
        tablerowdata = {};
      }
      return printTabledata;
    },

    selectionChange(selection) {
      this.checked = selection;
    },
    //全部通过
    allpass() {
      //console.log(this.checked);
      if (this.checked == undefined) {
        alert("至少先选择一条数据");
        return;
      }
      this.$confirm("确定全部通过吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "全部通过!",
            duration: "500",
          });
          //console.log(this.checked);
          var update_report_list = {
            update_report_list: [],
          };
          this.checked.forEach(function (value) {
            //console.log(value);
            value.zsflag = 4;
            var deleterowReportID = {
              // "is_confirmed": 1
            };
            value.is_confirmed = 1;
            deleterowReportID.daily_report_id = Number(value.daily_report_id);
            deleterowReportID.is_confirmed = value.is_confirmed;
            //console.log(deleterowReportID.daily_report_id);
            update_report_list.update_report_list.push(deleterowReportID);
          }, this);

          this.$http
            .post(
              IPConfig.IP + "/kpi-management/dailyreport/update.php",
              JSON.stringify(update_report_list),
              { emulateJSON: true }
            )
            .then();
        })
        .catch(() => {});
    },

    //改变部门id
    gbbumenId(params) {
      //console.log(params);
      var bumenid = { depart_id: params };
      localStorage.setItem("department", JSON.stringify(bumenid));
      this.getTableData();
    },
    //增加行
    restAdd() {
      console.log(this.depart_id);
      if (this.depart_id == 1) {
        var task_id = 450;
      }
      if (this.depart_id == 2) {
        var task_id = 451;
      }
      if (this.depart_id == 3) {
        var task_id = 452;
      }
      if (this.depart_id == 4) {
        var task_id = 453;
      }
      if (this.depart_id == 5) {
        var task_id = 454;
      }
      if (this.depart_id == 6) {
        var task_id = 455;
      }
      if (this.depart_id == 7) {
        var task_id = 456;
      }
      if (this.depart_id == 8) {
        var task_id = 457;
      }
      if (this.depart_id == 9) {
        var task_id = 458;
      }
      if (this.depart_id == 10) {
        var task_id = 459;
      }
      if (this.depart_id == 11) {
        var task_id = 460;
      }
      if (this.depart_id == 12) {
        var task_id = 464;
      }
      if (this.depart_id == 13) {
        var task_id = 491;
      }
      if (this.depart_id == 14) { //2013年04月14日添加，后面从后台获取
        var task_id = 492;
      }
      var value1 = getTaskOptionValue(task_id, this.options);

      var scopeName = [];
      Object.assign(scopeName, value1);
      var porjectname = getOptionStrName(
        task_id,
        scopeName,
        this.getDepartAndProjectData
      );
      //console.log(porjectname);

      var v = {
        value1: value1,
        employee_id: "",
        employee_name: "",
        project_id: "16",
        task_id: task_id,
        daily_report_id: -1,
        phase_id: "14",
        work_hour: "",
        show_hour: "0",
        show_min: "0",
        overtimework: false,
        comments: "空",
        zsflag: 1,
        is_confirmed: 0,
        task_name_str: porjectname,
      };
      this.tableData.push(v);
      this.$nextTick(() => {
        this.$refs.multipleTable.bodyWrapper.scrollTop =
          this.$refs.multipleTable.bodyWrapper.scrollHeight;
      });
    },
  },
};
</script>

<style scoped lang="less">
.g-table {
  margin-top: 20px;
}
.page-title {
  font-size: 32px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 10px;
}
.breadcrumb {
  background-color: white;
  padding: 0.5rem;
  margin-bottom: 25px;
}
.table-container {
  border: 1px solid blue;
}
.form-container {
  padding: 10px;
}
.form-title {
  background-color: blue;
  color: white;
  padding: 0.5rem;
  text-align: left;
  margin-bottom: 5px;
}
.btn-container {
  overflow: hidden;
  .el-button {
    float: left;
  }
}
.search-input {
  width: 300px;
  float: left;
  margin-left: 10px;
  margin-right: 5px;
}
.el-table__body {
  td {
    padding: 0;
  }
}

.titleBumen {
  width: 140px !important;
  margin-left: 20px !important;
  color: red !important;
}
</style>


// WEBPACK FOOTER //
// src/views/rest/GetTable.vue